import { AddressVm } from "../../Models/AddressVm"
import { AuthorityVm } from "../../Models/AuthorityVm"
import { BusinessCardVm } from "../../Models/BusinessCardVm"
import { BusinessVm } from "../../Models/BusinessVm"
import { ControlCardVm } from "../../Models/ControlCardVm"
import { CountryCodeVm } from "../../Models/CountryCodeVm"
import { DriverCardVm } from "../../Models/DriverCardVm"
import { DriverLicenseVm } from "../../Models/DriverLicenseVm"
import { PersonVm } from "../../Models/PersonVm"
import { StatusVm } from "../../Models/StatusVm"
import { WorkshopCardVm } from "../../Models/WorkshopCardVm"
import { WorkshopVm } from "../../Models/WorkshopVm"
import { OrderVm } from "../../Models/OrderVm"
import { MemberStateVm } from "../../Models/MemberStateVm"
import { CheckIssuedCardResultVm } from "../../Models/CheckIssuedCardResultVm"
import { OfficerVm } from "../../Models/OfficerVm"


export const fetchModel = async <T>(method: string, url: string, param: string, model: new () => T): Promise<T[]> => {
    let requestInfo = {
        method: method.toUpperCase(),
        headers: {
            'Content-Type': "application/json"
        }
    }

    return new Promise((resolve, reject) => {
        if (param) {
            url = url + "/" + param
        }
        fetch(url, requestInfo)
            .then((res) => res.json())
            .then((result) => {
                if (result === undefined) {
                    reject("Failed response")
                }
                else if (!result.valid) {
                    reject("Failed response")
                }
                else if (result.empty) {
                    reject("No result")
                }
                let models: any[] = []
                for (let i = 0; i < result.entities.length; i++) {
                    let modelFilled = mapModel(result.entities[i], new model())

                    models.push(modelFilled)
                }
                resolve(models)
            }).catch((error) => {
                reject(error)
            })
    })

}


//Recursive method that fills the model with the correct values
const mapModel = (values: any, model: any): any => {
    let modelKeys = Object.keys(model);
    for (let i = 0; i < modelKeys.length; i++) {
        let mKey = modelKeys[i]
        let v = values[mKey.charAt(0).toLowerCase() + mKey.slice(1)]
        var m = getModel(mKey)

        if (m && v) {
            model[mKey] = mapModel(v, new m());
        }
        else {
            model[mKey] = v
        }
    }

    return model
}


//If a new model needs to be used, add it to this list
const getModel = (modelName: string) => {

    switch (modelName) {
        case "Address":
            return AddressVm;
        case "Authority":
            return AuthorityVm;
        case "BusinessCard":
            return BusinessCardVm;
        case "Business":
            return BusinessVm;
        case "ControlCard":
            return ControlCardVm;
        case "CountryCode":
            return CountryCodeVm;
        case "DriverCard":
            return DriverCardVm;
        case "DriverLicense":
            return DriverLicenseVm;
        case "Person":
            return PersonVm;
        case "Officer":
            return OfficerVm;
        case "Status":
            return StatusVm;
        case "WorkshopCard":
            return WorkshopCardVm;
        case "Workshop":
            return WorkshopVm;
        case "Order":
            return OrderVm;
        case "MemberState":
            return MemberStateVm;
        case "CheckIssuedCardResult":
            return CheckIssuedCardResultVm;
        default:
            return undefined;
    }
}